import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowleft_37WBZ",
  "use": "arrowleft_37WBZ-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"arrowleft_37WBZ\"><path d=\"M6.996 10.006c0-.26.1-.52.29-.71l4-4c.39-.39 1.03-.39 1.42 0 .39.39.39 1.03 0 1.42l-3.29 3.29 3.28 3.28c.39.39.39 1.03 0 1.42-.39.39-1.03.39-1.42 0l-3.99-3.99c-.19-.2-.29-.46-.29-.71z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol